import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('toggle-action', () => import(/* webpackMode: "lazy" */'./toggle-action'));
